import { ReactElement, memo } from 'react';
import { GeneratedIconProps } from '@foundation/Icon/IconProps';
/**
 * @deprecated Import Icons from `@frontify/fondue/components` instead.
 */
function IconTextBoxStack12(props: GeneratedIconProps): ReactElement<GeneratedIconProps> {
    const customClassName = 'tw-flex tw-items-center tw-justify-center tw-fill-current';
    return (
        <svg
            xmlns="http://www.w3.org/2000/svg"
            width={12}
            height={12}
            className={customClassName}
            name="IconTextBoxStack12"
            aria-hidden="true"
            {...props}
        >
            <g fill="none">
                <g clipPath="url(#TextBoxStack12)">
                    <path
                        fill="currentColor"
                        fillRule="evenodd"
                        d="M10.5 3h-7a.5.5 0 0 0-.5.5V4h5.5A1.5 1.5 0 0 1 10 5.5V8h.5a.5.5 0 0 0 .5-.5v-4a.5.5 0 0 0-.5-.5M10 9h.5A1.5 1.5 0 0 0 12 7.5v-4A1.5 1.5 0 0 0 10.5 2h-7A1.5 1.5 0 0 0 2 3.5V4h-.5A1.5 1.5 0 0 0 0 5.5v4A1.5 1.5 0 0 0 1.5 11h7A1.5 1.5 0 0 0 10 9.5zM1.5 5h7a.5.5 0 0 1 .5.5v4a.5.5 0 0 1-.5.5h-7a.5.5 0 0 1-.5-.5v-4a.5.5 0 0 1 .5-.5m1 1.5A.5.5 0 0 1 3 6h4.286a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5M3 8a.5.5 0 0 0 0 1h2.571a.5.5 0 1 0 0-1z"
                        clipRule="evenodd"
                    />
                </g>
                <defs>
                    <clipPath id="TextBoxStack12">
                        <path fill="#fff" d="M0 0h12v12H0z" />
                    </clipPath>
                </defs>
            </g>
        </svg>
    );
}
export default memo(IconTextBoxStack12);
